"use client";

import { c as _c } from "react/compiler-runtime";
import { PageLayout } from "@/components/ui/page-layout";
import { EASE_OUT_QUART, MOTION_DURATION } from "@/lib/animation-constants";
import { motion, useReducedMotion } from "motion/react";
import { useCallback, useState } from "react";
import { DashboardHeroLogo } from "./DashboardHeroLogo";
import { DashboardPromptInput } from "./DashboardPromptInput";
import { FeaturedTemplatesCarousel } from "./FeaturedTemplatesCarousel";
import { PromptIdeas } from "./PromptIdeas";
const DASHBOARD_INTRO = {
  logo: 0,
  title: 0.14,
  prompt: 0.24,
  ideas: 0.38
} as const;
export default function DashboardHomeClient() {
  const $ = _c(32);
  const shouldReduceMotion = useReducedMotion();
  const [introComplete, setIntroComplete] = useState(false);
  const templatesCanEnter = introComplete || Boolean(shouldReduceMotion);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIntroComplete(true);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const markIntroComplete = t0;
  let t1;
  if ($[1] !== shouldReduceMotion) {
    t1 = delay => shouldReduceMotion ? {
      duration: 0
    } : {
      duration: MOTION_DURATION.slow,
      delay,
      ease: EASE_OUT_QUART
    };
    $[1] = shouldReduceMotion;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const entranceTransition = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DashboardHeroLogo delay={DASHBOARD_INTRO.logo} />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== shouldReduceMotion) {
    t3 = shouldReduceMotion ? false : {
      opacity: 0,
      y: 14
    };
    $[4] = shouldReduceMotion;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 1,
      y: 0
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== entranceTransition) {
    t5 = entranceTransition(DASHBOARD_INTRO.title);
    $[7] = entranceTransition;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <motion.h1 initial={t3} animate={t4} transition={t5} className="text-ds-text-primary max-w-3xl text-center text-4xl font-medium tracking-tight">What would you like to automate?</motion.h1>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== shouldReduceMotion) {
    t7 = shouldReduceMotion ? false : {
      opacity: 0,
      y: 14
    };
    $[12] = shouldReduceMotion;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      opacity: 1,
      y: 0
    };
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== entranceTransition) {
    t9 = entranceTransition(DASHBOARD_INTRO.prompt);
    $[15] = entranceTransition;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <DashboardPromptInput />;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t7 || $[19] !== t9) {
    t11 = <motion.div initial={t7} animate={t8} transition={t9} className="w-full max-w-[600px]">{t10}</motion.div>;
    $[18] = t7;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = shouldReduceMotion ? 0 : DASHBOARD_INTRO.ideas;
  let t13;
  if ($[21] !== t12) {
    t13 = <PromptIdeas entranceDelay={t12} onEntranceComplete={markIntroComplete} />;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t11 || $[24] !== t13 || $[25] !== t6) {
    t14 = <section className="relative mx-auto flex w-full max-w-[1024px] flex-1 flex-col items-center justify-center gap-8 px-6 pb-16 pt-16">{t2}{t6}{t11}{t13}</section>;
    $[23] = t11;
    $[24] = t13;
    $[25] = t6;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== templatesCanEnter) {
    t15 = <FeaturedTemplatesCarousel animateWhen={templatesCanEnter} />;
    $[27] = templatesCanEnter;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t14 || $[30] !== t15) {
    t16 = <PageLayout contentPadding="p-0"><div className="relative flex min-h-[calc(100dvh-16px)] flex-col">{t14}{t15}</div></PageLayout>;
    $[29] = t14;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  return t16;
}